/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertTaskTemplate} from '../api'

export const useMutationUpsertTaskTemplate = createReactQueryMutationHook('upsertTaskTemplate', upsertTaskTemplate)
